import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f451132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "btn-left",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9.8 12 5 5a1 1 0 1 1-1.4 1.4l-5.7-5.7a1 1 0 0 1 0-1.4l5.7-5.7a1 1 0 0 1 1.4 1.4l-5 5z" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "btn-right",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m14.3 12.1-5-5a1 1 0 0 1 1.4-1.4l5.7 5.7a1 1 0 0 1 0 1.4l-5.7 5.7a1 1 0 0 1-1.4-1.4l5-5z" })
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "horizontal"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "tag" }, "XXXX")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "tag" }, "XXXXXXXX")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "tag" }, "XXXX")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "tag" }, "XXXXXXX")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "tag" }, "XXX")
], -1))
const _hoisted_12 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "categories",
  ref: "categoriesContainer"
}
const _hoisted_14 = { class: "category-title" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "product-img"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "product-content" }
const _hoisted_19 = { class: "product-name" }
const _hoisted_20 = { class: "product-price" }
const _hoisted_21 = { class: "product-desc" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "allergens"
}
const _hoisted_26 = {
  key: 1,
  class: "tag new"
}
const _hoisted_27 = {
  key: 2,
  class: "tag recommended"
}
const _hoisted_28 = {
  key: 3,
  class: "tag popular"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-sep" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = {
  key: 3,
  class: "categories"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "category-title" }, "XXXXXXXX"),
  /*#__PURE__*/_createElementVNode("div", { class: "category-product-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "product-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "product-name" }, "XXXXXXXXXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-price" }, "XXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-sep" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "category-product-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "product-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "product-name" }, "XXXXXXXXXXXXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-price" }, "XXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-sep" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "category-product-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "product-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "product-name" }, "XXXXXXXXXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-price" }, "XXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-sep" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "category-product-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "product-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "product-name" }, "XXXXXXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-price" }, "XXXXX"),
      /*#__PURE__*/_createElementVNode("div", { class: "product-sep" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "ion-padding" }
const _hoisted_35 = { class: "language-selector" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Català")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Español")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Français")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Deutsch")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Italiano")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Русский")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("عربي")
const _hoisted_44 = { class: "text-login" }
const _hoisted_45 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_horizontal = _resolveComponent("vue-horizontal")!
  const _component_item_info = _resolveComponent("item-info")!
  const _component_text_limit = _resolveComponent("text-limit")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_IonSelectOption = _resolveComponent("IonSelectOption")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ng_template = _resolveComponent("ng-template")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_edit_cart_item_modal = _resolveComponent("edit-cart-item-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        ref: "content",
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: _ctx.handleScroll
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            id: "container",
            class: _normalizeClass({ 'items-loading': _ctx.loading })
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.coverImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.coverImage
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_vue_horizontal, {
                  key: 0,
                  ref: "horizontal",
                  class: "horizontal",
                  button: false,
                  snap: "end",
                  "button-between": false
                }, {
                  "btn-prev": _withCtx(() => [
                    _hoisted_3
                  ]),
                  "btn-next": _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (category, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        ref_for: true,
                        ref: "menus",
                        class: "item",
                        key: category.category_id,
                        onClick: ($event: any) => (_ctx.scrollToCategory(i))
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["tag", { active: category.category_id === _ctx.activeCategoryId }])
                        }, _toDisplayString(category.category), 3)
                      ], 8, _hoisted_5))
                    }), 128))
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_12))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (category) => {
                    return (_openBlock(), _createElementBlock("div", {
                      ref_for: true,
                      ref: "categoryItems",
                      key: category.category_id
                    }, [
                      _createElementVNode("b", _hoisted_14, _toDisplayString(category.category), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "category-product-row",
                          key: item.item_id,
                          onClick: ($event: any) => (_ctx.openItem(item))
                        }, [
                          (item.image_thumb)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("img", {
                                  src: item.image_thumb,
                                  loading: "lazy"
                                }, null, 8, _hoisted_17)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createTextVNode(_toDisplayString(item.name) + " ", 1),
                              _createVNode(_component_item_info, { item: item }, null, 8, ["item"])
                            ]),
                            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$filters.currency(item.price)), 1),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_text_limit, {
                                text: item.desc,
                                limit: 100,
                                expandable: false
                              }, null, 8, ["text"]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["btn-fast-add", { 'active': _ctx.cartItemsIds[item.id] }])
                              }, [
                                (_ctx.cartItemsIds[item.id])
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "remove",
                                      onClick: ($event: any) => (_ctx.quickRemoveItem(item, $event))
                                    }, [
                                      _createVNode(_component_ion_icon, { icon: _ctx.removeCircle }, null, 8, ["icon"])
                                    ], 8, _hoisted_22))
                                  : _createCommentVNode("", true),
                                (_ctx.cartItemsIds[item.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.cartItemsIds[item.id]), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  class: "add",
                                  onClick: ($event: any) => (_ctx.quickAddItem(item, $event))
                                }, [
                                  _createVNode(_component_ion_icon, {
                                    class: _normalizeClass({ 'loading': item.loading }),
                                    icon: item.loading ? _ctx.reloadCircle : _ctx.addCircle
                                  }, null, 8, ["class", "icon"])
                                ], 8, _hoisted_24)
                              ], 2)
                            ]),
                            (_ctx.showAllergens && item.allergens.length > 0)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.allergens, (allergen) => {
                                    return (_openBlock(), _createElementBlock("li", { key: allergen }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass('eicon eicon-circle-' + allergen)
                                      }, null, 2)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (item.is_new)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("home.itemNew")), 1))
                              : _createCommentVNode("", true),
                            (item.is_recommended)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("home.itemRecommended")), 1))
                              : _createCommentVNode("", true),
                            (item.is_popular)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t("home.itemPopular")), 1))
                              : _createCommentVNode("", true),
                            _hoisted_29
                          ])
                        ], 8, _hoisted_15))
                      }), 128)),
                      _hoisted_30
                    ]))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.cartItems > 0 || _ctx.isAdminSession)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "cart-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCart(false)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("home.myOrder")) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.cartItems), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.cartItems === 0 && _ctx.totalItems > 0 && !_ctx.isAdminSession)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "cart-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCart(true)))
              }, _toDisplayString(_ctx.$t("home.pay")), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onIonScroll"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "is-open": _ctx.showLoginModal,
        "initial-breakpoint": 1,
        breakpoints: [1],
        "backdrop-dismiss": false,
        handle: false,
        "presenting-element": _ctx.$parent.$refs.ionRouterOutlet
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ng_template, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_ion_icon, { icon: _ctx.languageOutline }, null, 8, ["icon"]),
                  (_ctx.locales.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_select, {
                        key: 0,
                        onIonChange: _ctx.setLang,
                        modelValue: _ctx.$i18n.locale,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
                        interface: "popover",
                        placeholder: "",
                        class: "select-lang"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.locales.includes('ca'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 0,
                                value: "ca"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('es'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 1,
                                value: "es"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('en'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 2,
                                value: "en"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('fr'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 3,
                                value: "fr"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_39
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('de'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 4,
                                value: "de"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_40
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('it'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 5,
                                value: "it"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_41
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('ru'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 6,
                                value: "ru"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_42
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.locales.includes('ar'))
                            ? (_openBlock(), _createBlock(_component_IonSelectOption, {
                                key: 7,
                                value: "ar"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_43
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onIonChange", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("home.yourNameTitle")), 1),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "login-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeUser && _ctx.changeUser(...args))),
                    autocomplete: "off",
                    placeholder: _ctx.$t('home.yourNamePlaceholder')
                  }, null, 40, _hoisted_45), [
                    [_vModelText, _ctx.form.name]
                  ])
                ]),
                _createVNode(_component_ion_item, { class: "show-ingredients" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("home.showAllergens")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_toggle, {
                      slot: "end",
                      modelValue: _ctx.showAllergens,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAllergens) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, { class: "over-18" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("home.over18")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_toggle, {
                      slot: "end",
                      modelValue: _ctx.over18,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.over18) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  class: "primary-btn btn-login",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                }, _toDisplayString(_ctx.$t("home.viewMenu")), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "presenting-element"]),
      _createVNode(_component_edit_cart_item_modal, {
        onUpdate: _ctx.handleEditedCartItem,
        ref: "editCartItemModal"
      }, null, 8, ["onUpdate"])
    ]),
    _: 1
  }))
}